import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { deliveryLabel, deliveryDate } from "@/lib/metaUtil";
import { FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EpisodeListCard(_ref) {
  var _item$channel;
  let {
    item
  } = _ref;
  const channelId = Number(item === null || item === void 0 || (_item$channel = item.channel) === null || _item$channel === void 0 ? void 0 : _item$channel.id);
  const showValuePlanLabel = isShowValuePlanLabel({
    channelId
  });
  const handleClick = useCallback(e => {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.list, {
      [styles.notAllowed]: !item.isAllowedRating
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: routes.watchWithRtsid(item),
          linkAttr: {
            onClick: handleClick
          },
          showValuePlanLabel: showValuePlanLabel
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(VersatileLink, {
            href: routes.watchWithRtsid(item),
            children: /*#__PURE__*/_jsx("a", {
              onClick: handleClick,
              children: item.name
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.delivery,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.deliveryItem,
            children: [/*#__PURE__*/_jsx("span", {
              children: deliveryLabel(item)
            }), " ", /*#__PURE__*/_jsx("span", {
              children: deliveryDate(item)
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.tags,
            children: [/*#__PURE__*/_jsx("span", {
              children: item.genres.map(genre => genre.name).join("/")
            }), item.production_year && /*#__PURE__*/_jsx("span", {
              children: item.production_year
            }), item.duration && /*#__PURE__*/_jsxs("span", {
              children: [Math.floor(item.duration / 60), "\u5206"]
            })]
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FavoriteButton, {
          listRow: true,
          metaId: item.id
        })
      })]
    })
  });
}